// removed by extract-text-webpack-plugin
module.exports = {"ContactData":"ContactData__ContactData__1whvJ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Checkout/ContactData/ContactData.css
// module id = 142
// module chunks = 0